import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
        values: {
            // concert
            concertMore: 'mdi-comment-arrow-right',
        }
    },
    theme: {
        themes: {
            light: {
                primary: '#333',
                secondary: '#666',
                accent: '#999'
            }
        }
    }
})
